import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Family } from './pages/Family';
import { Menu } from './pages/Menu';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fa87r4ui0o4u">
      <div className="min-h-screen flex flex-col w-full bg-cream selection:bg-warm-brown selection:text-white" data-id="element-1" data-mp="3fbt3gxsjud4a">
        {/* Desktop Left Brick Edge - Mimicking the building facade */}
        <div className="hidden lg:block fixed left-0 top-0 bottom-0 w-12 xl:w-16 brick-pattern z-50 shadow-[4px_0_15px_rgba(0,0,0,0.4)] border-r border-dark-brick" data-id="element-2" data-mp="2mmlvz9b4ad6w"></div>

        {/* Main Content Wrapper - Offset for the left brick edge on desktop */}
        <div className="flex-1 lg:ml-12 xl:ml-16 relative" data-id="element-3" data-mp="2wi5nzkmk8rqd">
          <Header data-id="element-4" data-mp="28t4kmbsl46ry" />

          <main data-id="element-5" data-mp="28sl5f2ubjwhm">
            <Routes data-id="element-6" data-mp="28s2ztflro5x1">
              <Route path="/" element={<Home data-id="element-8" data-mp="23u9ueosaffxt" />} data-id="element-7" data-mp="23vkzqt1dsvr1" />
              <Route path="/family" element={<Family data-id="element-10" data-mp="3ijxpqrsp22kf" />} data-id="element-9" data-mp="23v2rey1g2r2r" />
              <Route path="/menu" element={<Menu data-id="element-12" data-mp="3ij61k21ff746" />} data-id="element-11" data-mp="3ikr002qv3a7b" />
            </Routes>
          </main>

          <Footer data-id="element-13" data-mp="3ml13n8r6loj0" />
        </div>
      </div>
    </BrowserRouter>;
}